import React from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from "@material-ui/core";

/**
 * The app's single confirmation dialog. `destructive` styles the confirm
 * button for irreversible actions.
 */
export default function Confirm({
  title,
  confirmText,
  open,
  confirmAction,
  cancelAction,
  destructive,
  children,
}) {
  return (
    <Dialog open={open} onClose={cancelAction} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={cancelAction}>Cancel</Button>
        <Button
          color={destructive ? "secondary" : "primary"}
          variant="contained"
          onClick={confirmAction}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
